import { useEffect } from "react";
import { BRAND_DARK } from "@/shared/constants.js";
import { btnPrimary } from "@/shared/utils/styles.js";

/**
 * Shared modal wrapper: overlay + header (title + ×) + scrollable body +
 * footer (Close button). Escape key closes the modal.
 */
export default function ModalShell({ title, onClose, children }) {
  useEffect(() => {
    const onKeyDown = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 100, padding: 16,
    }}>
      <div style={{
        background: "#fff", borderRadius: 16, maxHeight: "85%", width: "100%", maxWidth: 560,
        display: "flex", flexDirection: "column", overflow: "hidden",
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", borderBottom: "1px solid #f0f0f0" }}>
          <span style={{ fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif", fontSize: 16, fontWeight: 700, color: BRAND_DARK }}>{title}</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, color: "#999", padding: 0, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ overflowY: "auto", padding: "16px 18px", fontSize: 12, color: "#555", lineHeight: 1.7, fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" }}>
          {children}
        </div>
        <div style={{ padding: "10px 18px", borderTop: "1px solid #f0f0f0" }}>
          <button onClick={onClose} style={{ ...btnPrimary, fontSize: 13, padding: "11px 0", fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" }}>Close</button>
        </div>
      </div>
    </div>
  );
}
